import type { LocationQuery } from 'vue-router'

export type TabOptions = {
  id: string
  title: string
  path: string
  query?: LocationQuery
  content?: string
  props?: Record<string, any>
  isCachable?: boolean
  isActive?: boolean
  isClosable?: boolean
}

export type TabLike = TabOptions

export class Tab {
  public id: string
  public title: string
  public path: string
  public query?: LocationQuery
  public props?: Record<string, any>
  public isCachable?: boolean
  public isInitialized?: boolean
  public isActive?: boolean
  public isClosable?: boolean
  constructor(options: TabOptions) {
    const {
      id,
      title,
      path,
      query,
      props,
      isActive,
      isCachable = true,
      isClosable = true
    } = options
    this.id = id
    this.title = title
    this.path = path
    this.query = query
    this.props = props
    this.isCachable = isCachable
    this.isActive = isActive
    this.isClosable = isClosable
  }

  get url() {
    const query = []
    for (const key in this.query) {
      const value = this.query[key]
      query.push(`${key}=${value !== null ? value.toString() : value}`)
    }
    const url = query.length > 0 ? `${this.path}?${query.join('&')}` : this.path
    return url
  }
}
